function RenderSubSectionTitle({ text }) {
  return (
    <div
      style={{
        textTransform: "uppercase",
        borderLeft: "1px solid grey",
        letterSpacing: "1mm",
        paddingLeft: "5px",
        borderBottom: "1px solid grey",
        width: "fit-content",
        fontSize: "small",
        marginBottom: "10px",
        marginTop: "5px",
      }}
    >
      {text}
    </div>
  );
}

export default RenderSubSectionTitle;
